import { useState, useCallback } from "react";

const usePagination = (fetchFn, initialPage = 1) => {
  const [currentPage, setCurrentPage] = useState(initialPage);

  const goToPage = useCallback(
    (page) => {
      setCurrentPage(page);
      fetchFn(page);
    },
    [fetchFn]
  );

  const nextPage = useCallback(
    (pagination) => {
      if (pagination?.next_page) goToPage(pagination.next_page);
    },
    [goToPage]
  );

  const prevPage = useCallback(
    (pagination) => {
      if (pagination?.previous_page) goToPage(pagination.previous_page);
    },
    [goToPage]
  );

  const resetPage = useCallback(() => {
    setCurrentPage(1);
    fetchFn(1);
  }, [fetchFn]);

  return { currentPage, goToPage, nextPage, prevPage, resetPage };
};

export default usePagination;
